module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_11.png?94bfc614c628392827a89a4e42a4fc27";